import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import toast from "react-hot-toast";
import { Helpers } from '../../../helpers/Helpers';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import RefreshButton from '../../../components/RefreshButton';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { GetJnjPaymentListRequest, initialGetJnjPaymentListRequest } from '../../../models/request/jnjPayment/GetJnjPaymentListRequest';
import { GetJnjPaymentListResponse, GetJnjPaymentListResponseData, GetJnjPaymentListResponseItem, initialGetJnjPaymentListResponseData } from '../../../models/response/jnjPayment/GetJnjPaymentListResponse';
import { GetJnjPaymentStatusResponse, GetJnjPaymentStatusResponseData } from '../../../models/response/jnjPayment/GetJnjPaymentStatusResponse';
import { BaseJnjPaymentResponse } from '../../../models/response/jnjPayment/BaseJnjPaymentResponse';
import { JnjPaymentService } from '../../../services/JnjPaymentService';
import JnjPaymentListFilters from './Components/JnjPaymentListFilters';
import { jnjStatusHint, jnjStatusTone } from './jnjStatusTone';

/** Çekim sürerken durum bu aralıkla sorulur. */
const POLL_MS = 4000;

/**
 * Ön Muhasebe > İşlemler > J&J Ödeme Durumu (Burak, 07.10.2026).
 * PO Eşleştirme'de Yurtiçi Kargo projesi seçili ve bugün tarih aralığında olan PO numaraları J&J tedarikçi
 * portalında (ap.jnj.com) sorgulanır; her gün 08:00'de otomatik, ayrıca "Şimdi Çek" ile elle.
 */
const JnjPaymentList = () => {
    const dispatch = useDispatch();
    const pageName = "Ön Muhasebe > İşlemler > J&J Ödeme Durumu"
    // 2: Durum / Durum Açıklaması Türkçe kolonlara geçti (J&J'nin İngilizcesi gizli kolonlarda).
    // 3: Vergi Tutarı Vade Tarihi'nin yanına; Önceki Durum / Durum Değişim Tarihi kaldırıldı (Burak, 07.10.2026).
    // 4: Mükerrer Red kolonu Durum Açıklaması'nın yanına (15.10.2026).
    const pageVersion = "4";
    const [data, setData] = useState<GetJnjPaymentListResponseData>(initialGetJnjPaymentListResponseData);
    const [filter, setFilter] = useState<GetJnjPaymentListRequest>(initialGetJnjPaymentListRequest)
    const [status, setStatus] = useState<GetJnjPaymentStatusResponseData | undefined>(undefined);

    // Durum filtresinin seçenekleri: firmanın kayıtlarındaki Türkçe durumlar (sunucudan, yeni durum gelince kendiliğinden eklenir).
    const loadStatusOptions = async (): Promise<ColumnFilterOption[]> => {
        var response: GetJnjPaymentStatusResponse = await JnjPaymentService.getJnjPaymentStatus();

        return response.isSuccess ? response.data.statusOptions.map(x => ({ value: x, label: x })) : [];
    }

    const changeOnlyEmptyDueDate = (checked: boolean) => {
        getData({ ...filter, onlyEmptyDueDate: checked ? true : undefined, currentPage: 1, skip: 0 });
    }

    const changeOnlyEmptyPaymentDate = (checked: boolean) => {
        getData({ ...filter, onlyEmptyPaymentDate: checked ? true : undefined, currentPage: 1, skip: 0 });
    }

    const setItemSelected = (_id: string) => {
        setData({ ...data, items: data.items.map(x => x.jnjPaymentRecordId == _id ? { ...x, isSelected: !x.isSelected } : x) })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length > 0 && data.items.every(x => x.isSelected);

        setData({ ...data, items: data.items.map(x => ({ ...x, isSelected: !isAllSelected })) })
    }

    const selectedIds = data.items.filter(x => x.isSelected).map(x => x.jnjPaymentRecordId);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'PO Numarası', name: 'poNumber', order: 0, isVisible: true },
            { title: 'Fatura No', name: 'invoiceNumber', order: 0, isVisible: true },
            { title: 'Fatura Tarihi', name: 'invoiceDateStr', order: 0, isVisible: true },
            { title: 'Vade Tarihi', name: 'invoiceDueDateStr', order: 0, isVisible: true },
            { title: 'Vergi Tutarı', name: 'taxAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Fatura Tutarı (Vergi Dahil)', name: 'totalInvoiceAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Döviz', name: 'currency', order: 0, isVisible: true },
            { title: 'Durum', name: 'invoiceStatusTr', order: 0, isVisible: true },
            { title: 'Durum Açıklaması', name: 'invoiceStatusDetailTr', order: 0, isVisible: true },
            { title: 'Mükerrer Red', name: 'mukerrerRed', order: 0, isVisible: true },
            { title: 'Ödenen Tutar', name: 'invoicePaidAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Ödeme Tarihi', name: 'paymentDateStr', order: 0, isVisible: true },
            { title: 'Toplam Ödeme Tutarı', name: 'totalPaymentAmount', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'J&J Şirketi', name: 'jnjCompanyName', order: 0, isVisible: true },
            { title: 'Son Görülme', name: 'lastSeenDateStr', order: 0, isVisible: true },
            { title: 'Durum (J&J, İngilizce)', name: 'invoiceStatus', order: 0, isVisible: false },
            { title: 'Durum Açıklaması (J&J, İngilizce)', name: 'invoiceStatusDetail', order: 0, isVisible: false },
            { title: 'Sorgulanan PO', name: 'searchedPoNo', order: 0, isVisible: false },
            { title: 'Çek / EFT No', name: 'checkEftTraceNo', order: 0, isVisible: false },
            { title: 'Çek Tahsil Tarihi', name: 'checkCashedDateStr', order: 0, isVisible: false },
            { title: 'Tedarikçi No', name: 'supplierNumber', order: 0, isVisible: false },
            { title: 'Invoice Log ID / Yıl', name: 'invoiceLogId', order: 0, isVisible: false },
            { title: 'J&J Şirket Kodu', name: 'jnjCompanyCode', order: 0, isVisible: false },
            { title: 'Item Text', name: 'itemText', order: 0, isVisible: false },
            { title: 'Clearing Document', name: 'clearingDocument', order: 0, isVisible: false },
            { title: 'FI Belge No', name: 'fiDocumentNumber', order: 0, isVisible: false },
            { title: 'Dinamik İskonto', name: 'dynamicDiscount', order: 0, isVisible: false },
            { title: 'İlk Görülme', name: 'firstSeenDateStr', order: 0, isVisible: false },
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);
    const pollTimer = useRef<any>(undefined);
    // Çekim bitince liste o anki filtreyle yenilensin (zamanlayıcıdaki kapanış eski filtreyi görür).
    const filterRef = useRef<GetJnjPaymentListRequest>(filter);

    // Panodaki "J&J Ödeme Durumları" kartından gelindiyse liste o kartın durum + fatura tarihi filtresiyle açılır (09.10.2026).
    const location = useLocation();
    const gelenFiltreler: ColumnFilterModel[] | undefined = (location.state as any)?.columnFilters;
    const ilkAcilis = useRef(true);

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getStatus();

        return () => clearTimeout(pollTimer.current);
    }, [])

    useEffect(() => {
        if (gelenFiltreler && gelenFiltreler.length > 0)
            getData({ ...filter, columnFilters: gelenFiltreler, currentPage: 1, skip: 0 });
        else if (ilkAcilis.current)
            getData();

        ilkAcilis.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key])

    const getData = async (_filter: GetJnjPaymentListRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            filterRef.current = _filter;
            dispatch(storeActivityIndicator(true))

            var response: GetJnjPaymentListResponse = await JnjPaymentService.getJnjPaymentListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    /**
     * Üst bilgi (son çekim, bugünkü PO'lar, yetki). Çekim sürüyorsa bitene kadar tekrar sorulur;
     * bitince sonuç mesajı gösterilir ve liste yenilenir.
     */
    const getStatus = async (afterFetch: boolean = false) => {
        try {
            var response: GetJnjPaymentStatusResponse = await JnjPaymentService.getJnjPaymentStatus();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setStatus(response.data);
            clearTimeout(pollTimer.current);

            if (response.data.isRunning) {
                pollTimer.current = setTimeout(() => getStatus(true), POLL_MS);
            }
            else if (afterFetch) {
                if (response.data.lastRunSucceeded)
                    toast.success(response.data.lastRunMessage ?? 'J&J çekimi tamamlandı.')
                else
                    toast.error(response.data.lastRunMessage ?? 'J&J çekimi hatalı bitti.')

                getData(filterRef.current);
            }
        } catch (error: any) {
            toast.error(error)
        }
    }

    const fetchNow = async () => {
        try {
            var response: BaseJnjPaymentResponse = await JnjPaymentService.fetchJnjPayments();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            toast.success(response.message)
            setStatus(status ? { ...status, isRunning: true } : status);
            pollTimer.current = setTimeout(() => getStatus(true), POLL_MS);
        } catch (error: any) {
            toast.error(error)
        }
    }

    const performPagination = (i: number) => {
        getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });
    }

    const changeTake = (_take: number) => {
        getData({ ...filter, currentPage: 1, skip: 0, take: _take });
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData({ ...filter, currentPage: 1, skip: 0 });
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: BaseJnjPaymentResponse = await JnjPaymentService.exportJnjPaymentList(buildExcelRequest(filter, mode, selectedIds, columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar (JnjPaymentManager.ApplySort ile aynı adlar).
    const sortableColumns = [
        'searchedPoNo', 'poNumber', 'invoiceNumber', 'invoiceDateStr', 'invoiceDueDateStr',
        'totalInvoiceAmount', 'taxAmount', 'invoicePaidAmount', 'totalPaymentAmount',
        'invoiceStatus', 'invoiceStatusTr', 'invoiceStatusDetailTr', 'paymentDateStr', 'invoiceLogId', 'itemText', 'lastSeenDateStr'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler (JnjPaymentManager.ApplyColumnFilters ile aynı adlar).
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        searchedPoNo: { type: 'text' },
        poNumber: { type: 'text' },
        invoiceNumber: { type: 'text' },
        invoiceDateStr: { type: 'date' },
        invoiceDueDateStr: { type: 'date' },
        totalInvoiceAmount: { type: 'number' },
        taxAmount: { type: 'number' },
        invoicePaidAmount: { type: 'number' },
        totalPaymentAmount: { type: 'number' },
        // Durum seçimli: seçenekler bu firmanın kayıtlarındaki Türkçe durumlar ("(Boş)" ile).
        invoiceStatusTr: { type: 'select', loadOptions: loadStatusOptions, renderOption: (label) => statusBadge(label) },
        invoiceStatusDetailTr: { type: 'text' },
        // Mükerrer red: aynı fatura no + tarihle Ödendi kaydı olan Reddedildi (panodaki Reddedildi kartı Hayır ile açar).
        mukerrerRed: { type: 'select', loadOptions: async () => [{ value: 'Evet', label: 'Evet' }, { value: 'Hayır', label: 'Hayır' }] },
        invoiceStatus: { type: 'text' },
        invoiceStatusDetail: { type: 'text' },
        checkEftTraceNo: { type: 'text' },
        paymentDateStr: { type: 'date' },
        invoiceLogId: { type: 'text' },
        jnjCompanyName: { type: 'text' },
        itemText: { type: 'text' },
        clearingDocument: { type: 'text' },
        fiDocumentNumber: { type: 'text' },
        lastSeenDateStr: { type: 'date' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const statusBadge = (text: string | undefined, toneSource: string | undefined = undefined) => {
        if (!text)
            return null;

        const tone = jnjStatusTone(toneSource ?? text);

        return <span title={toneSource && toneSource != text ? 'J&J: ' + toneSource : jnjStatusHint(text)} className={'badge ' + (tone == 'light' ? 'badge-light' : 'badge-light-' + tone) + ' ebbe-status-badge'}>{text}</span>
    }

    const getColumnValue = (item: GetJnjPaymentListResponseItem, column: string, className: string | undefined) => {
        var item2: any = item;

        if (column == "invoiceStatusTr") {
            // Türkçe metin, renk J&J'nin İngilizce durumundan (bilinmeyen çeviride de doğru renk).
            return <td className={className}>{statusBadge(item.invoiceStatusTr, item.invoiceStatus)}</td>;
        }
        else if (column == "mukerrerRed") {
            // Yalnız Reddedildi satırında anlamlı; mükerrer olanlar uyarı rengiyle.
            return <td className={className}>{item.invoiceStatusTr == 'Reddedildi' ? <span className={'badge ' + (item.mukerrerRed == 'Evet' ? 'badge-light-warning' : 'badge-light') + ' ebbe-status-badge'} title={item.mukerrerRed == 'Evet' ? 'Aynı faturanın Ödendi kaydı var; panoda Reddedildi sayılmaz' : undefined}>{item.mukerrerRed}</span> : null}</td>;
        }
        else if (column == "invoiceStatus") {
            return <td className={className}>{statusBadge(item2[column])}</td>;
        }
        else if (['totalInvoiceAmount', 'taxAmount', 'invoicePaidAmount', 'totalPaymentAmount'].includes(column)) {
            return <td className={className}>{item2[column] != null ? Helpers.correctPrice(item2[column], 2) : ''}</td>;
        }
        else {
            return <td className={className}>{item2[column]}</td>;
        }
    }

    const visibleColumns = columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; });

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => { getData(); getStatus(); }} />
                <JnjPaymentListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    setFilter={setFilter}
                    onSearchSubmit={onSearchSubmit}
                    selectedCount={selectedIds.length}
                    canFetch={status?.canFetch == true && status?.isConfigured == true}
                    isRunning={status?.isRunning == true}
                    onFetch={fetchNow}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                {
                    status && (
                        <KTCard className='mb-3'>
                            <KTCardBody className='py-3'>
                                {
                                    !status.isConfigured && (
                                        <div className='text-danger fw-bold mb-2'>
                                            J&J entegrasyonu bu firma için tanımlı değil. Ayarlar &gt; Entegrasyon Ayarları'na "J&J Ödeme Durumu" kaydı (kullanıcı adı / şifre) eklenmeli.
                                        </div>
                                    )
                                }
                                {/* Etiketler siyah, değerler kırmızı; PO'ların hepsi yazılır (Burak, 08.10.2026). */}
                                <div className='d-flex flex-wrap gap-5 text-gray-900'>
                                    <div>
                                        <span className='me-1'>Son çekim:</span>
                                        <span className='text-danger fw-bold'>
                                            {status.isRunning ? 'Çalışıyor…' : (status.lastRunStr ?? 'Henüz çekilmedi')}
                                        </span>
                                    </div>
                                    <div>
                                        <span className='me-1'>Bugün sorgulanacak PO:</span>
                                        <span className='text-danger fw-bold'>
                                            {status.poNumbers.length}{status.poNumbers.length > 0 && ' (' + status.poNumbers.join(', ') + ')'}
                                        </span>
                                    </div>
                                    <div>Otomatik: her gün 08:00</div>
                                </div>
                                {/* Filtreler alt satırda yan yana: önce vade, sonra ödeme tarihi; yazı kalın siyah, sayı kırmızı. */}
                                <div className='d-flex flex-wrap gap-8 mt-3'>
                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            checked={filter.onlyEmptyDueDate == true}
                                            onChange={(e) => changeOnlyEmptyDueDate(e.target.checked)}
                                        />
                                        <span className='form-check-label fw-bold text-gray-900'>
                                            Yalnız vade tarihi boş olanlar <span className='text-danger'>({status.emptyDueDateCount})</span>
                                        </span>
                                    </label>
                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                        <input
                                            className='form-check-input'
                                            type='checkbox'
                                            checked={filter.onlyEmptyPaymentDate == true}
                                            onChange={(e) => changeOnlyEmptyPaymentDate(e.target.checked)}
                                        />
                                        <span className='form-check-label fw-bold text-gray-900'>
                                            Yalnız ödeme tarihi boş olanlar <span className='text-danger'>({status.emptyPaymentDateCount})</span>
                                        </span>
                                    </label>
                                </div>
                                {
                                    !status.isRunning && status.lastRunSucceeded == false && status.lastRunMessage && (
                                        <div className='text-danger mt-2'>{status.lastRunMessage}</div>
                                    )
                                }
                            </KTCardBody>
                        </KTCard>
                    )
                }

                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            {/* id='kt_table_users': diğer listelerdeki belirgin satır / sütun çizgileri bu kimliğe bağlı (CustomCss.css). */}
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table ebbe-table-fill'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.length > 0 && data.items.every(x => x.isSelected)} />
                                                </label>
                                            </div>
                                        </th>
                                        {
                                            visibleColumns.map((item) =>
                                                <th {...thProps(item.name)}>{item.title}{sortArrow(item.name)}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={visibleColumns}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item) =>
                                            <tr key={item.jnjPaymentRecordId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                            <input onChange={() => setItemSelected(item.jnjPaymentRecordId)} className='form-check-input' type='checkbox' checked={item.isSelected == true} />
                                                        </label>
                                                    </div>
                                                </td>
                                                {
                                                    visibleColumns.map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={selectedIds.length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default JnjPaymentList;
